import React from "react";

import idGrey from "../../assets/LogsListAssets/idgrey.svg";
import loadGrey from "../../assets/LogsListAssets/loadgrey.svg";
import calendarGrey from "../../assets/LogsListAssets/calendargrey.svg";
import clockGrey from "../../assets/LogsListAssets/clockgrey.svg";
import occuranceGrey from "../../assets/LogsListAssets/occurencegrey.svg";
// import resultGrey from "../../assets/LogsListAssets/resultgrey.svg";
// import errorGrey from "../../assets/LogsListAssets/errorgrey.svg";

const TaskListContents = (props) => {
  const { logItem } = props;

  return (
    <div className="flex items-center gap-3">
      <table className="my-2 text-[#868A97] text-xs log-list-table-1">
        <tr>
          <td>
            <img src={idGrey} alt="" />
          </td>
          <td>Task ID</td>
          <td>{logItem.id}</td>
        </tr>
        <tr>
          <td>
            <img src={loadGrey} alt="" />
          </td>
          <td>Status</td>
          <td>
            <span
              className={`border rounded-full w-10 text-[11px] px-2 py-[1px] ${logItem.status === "Scheduled"
                ? "border-[#00A2FF] text-[#00A2FF] bg-[#E9F7FF] "
                : logItem.status === "Completed"
                  ? "border-[#00BB25] text-[#00BB25] bg-[#E5F8E8]"
                  : "border-[#EB0000] text-[#EB0000] bg-[#FFF3F3]"
                }`}
            >
              {logItem.status}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <img src={calendarGrey} alt="" />
          </td>
          <td>Created</td>
          <td>{logItem.created}</td>
        </tr>
      </table>
      <table className="my-2 text-[#868A97] text-xs log-list-table-2">
        {logItem.date && (
          <tr>
            <td>
              <img src={clockGrey} alt="" />
            </td>
            <td>Date</td>
            <td>{new Date(logItem.date).toLocaleDateString()}</td>
          </tr>
        )}
        {logItem.startDate && (
          <tr>
            <td>
              <img src={clockGrey} alt="" />
            </td>
            <td>Start Date</td>
            <td>{new Date(logItem.startDate).toLocaleDateString()}</td>
          </tr>
        )}
        {logItem.endDate && (
          <tr>
            <td>
              <img src={clockGrey} alt="" />
            </td>
            <td>End Date</td>
            <td>{new Date(logItem.endDate).toLocaleDateString()}</td>
          </tr>
        )}       
        <tr>
          <td>
            <img src={occuranceGrey} alt="" />
          </td>
          <td>Occurence</td>
          <td>{logItem.occurrence} @ {logItem?.time? logItem.time: ""}</td>
        </tr>
      </table>
      {/* <table className="my-2 text-[#868A97] text-xs log-list-table-3">
        <tr>
          <td>
            <img src={clockGrey} alt="" />
          </td>
          <td>Duration</td>
          <td>{logItem.duration}</td>
        </tr>
        <tr>
          <td>
            <img src={resultGrey} alt="" />
          </td>
          <td>Result</td>
          <td>{logItem.result}</td>
        </tr>
        <tr>
          <td>
            <img src={errorGrey} alt="" />
          </td>
          <td>Error</td>
          <td>{logItem.error}</td>
        </tr>
      </table> */}
    </div>
  );
};

export default TaskListContents;
